// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2411":"23df3f73","3013":"23df3f73","4056":"23df3f73","4441":"23df3f73","8623":"23df3f73","8734":"23df3f73","9245":"33ba5c92"}[chunkId] + ".chunk.css";
};